module.exports = __webpack_public_path__ + "static/media/event-services-img9.8a1a5995.jpg";